/** All available BRS task kinds */
export enum TaskKindEnum {
  /** Payment for supplier BRS task */
  PAYMENT_TO_SUPPLIER = 'PAYMENT_TO_SUPPLIER',
  /** Payment for self-employed BRS task */
  PAYMENT_TO_SELF_EMPLOYED = 'PAYMENT_TO_SELF_EMPLOYED',
  /** Payment of taxes BRS task */
  PAYMENT_OF_TAXES = 'PAYMENT_OF_TAXES',
  /** Payment of salary BRS task */
  PAYMENT_OF_SALARY = 'PAYMENT_OF_SALARY',
}
